import { createRouter, createWebHistory } from "vue-router";
import Snippets from "../views/Snippets.vue";
import Dashboard from "../views/Dashboard.vue";
import SupportChat from "../views/Support/Chat.vue";
// sections
import SectionOverview from "../views/Section/Overview.vue";
import SectionCreate from "../views/Section/Create.vue";
import SectionDetails from "../views/Section/Details.vue";
// employees
import EmployeesOverview from "../views/Employees/Overview.vue";
import EmployeeCreate from "../views/Employees/Create.vue";
import EmployeeEdit from "../views/Employees/Edit.vue";
import EmployeeDetails from "../views/Employees/Details.vue";
// categories
import CategoryOverview from "../views/Category/Overview.vue";
// settings
import SettingsOverview from "../views/Settings/Overview.vue";
// integrations
import IntegrationsOverview from "../views/Integrations/Overview.vue";
// auth and others
import Pipeline from "../views/Pipeline.vue";
import ReviewsOverview from "../views/Reviews/Overview.vue";
import TasksOverview from "../views/Tasks/Overview.vue";
import GuidesOverview from "../views/Guides/Overview.vue";
import Login from "../views/Auth/Login.vue";
import GetStarted from "../views/Auth/GetStarted.vue";
import axios from "axios";

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/",
    redirect: "/dashboard",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/support",
    name: "SupportChat",
    component: SupportChat,
  },
  {
    path: "/pipeline",
    name: "Pipeline",
    component: Pipeline,
  },
  {
    path: "/reviews",
    name: "ReviewsOverview",
    component: ReviewsOverview,
  },
  {
    path: "/tasks",
    name: "TasksOverview",
    component: TasksOverview,
  },
  {
    path: "/anleitungen",
    name: "GuidesOverview",
    component: GuidesOverview,
  },
  // administration
  {
    path: "/employees",
    name: "EmployeesOverview",
    component: EmployeesOverview,
  },
  {
    path: "/employee/create",
    name: "EmployeeCreate",
    component: EmployeeCreate,
  },
  {
    path: "/employee/edit/:id",
    name: "EmployeeEdit",
    component: EmployeeEdit,
  },
  {
    path: "/employee/:id",
    name: "EmployeeDetails",
    component: EmployeeDetails,
  },
  // sections
  {
    path: "/sections",
    name: "SectionOverview",
    component: SectionOverview,
  },
  {
    path: "/section/create",
    name: "SectionCreate",
    component: SectionCreate,
  },
  {
    path: "/section/:id",
    name: "SectionDetails",
    component: SectionDetails,
  },
  // snippets
  {
    path: "/snippets",
    name: "Snippets",
    component: Snippets,
  },
  // categories
  {
    path: "/categories",
    name: "CategoryOverview",
    component: CategoryOverview,
  },
  // settings
  {
    path: "/settings",
    name: "SettingsOverview",
    component: SettingsOverview,
  },
  // integrations
  {
    path: "/integrations",
    name: "IntegrationsOverview",
    component: IntegrationsOverview,
  },
  // get-started
  {
    path: "/get-started/:id",
    name: "GetStarted",
    component: GetStarted,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  axios
    .post("/api/authorization/check")
    .then((response) => {
      const isAuthenticated = response.data.success;

      if (!isAuthenticated && to.name !== "Login" && to.name !== "GetStarted") {
        return next({ name: "Login" });
      }

      next();
    })
    .catch(() => {
      if (to.name !== "Login" && to.name !== "GetStarted") {
        next({ name: "Login" });
      } else {
        next();
      }
    });
});

export default router;
